import { loginThunk } from "../../../redux/auth.reducer";
import api from "../../../utils/useApi";
import {
  FunctionGetUsername,
  GetPhoneNumber,
} from "../../../utils/useFunction";

const LoginNoBKB = async ({ values, dispatch, phoneCode, navigate, cart }) => {
  const uniqueKey = new Date().getTime();

  const username = GetPhoneNumber(values);
  sessionStorage.setItem("pre-data", FunctionGetUsername(username));

  try {
    const {
      data: { profiles },
    } = await api.get(`/profiles?username=${FunctionGetUsername(values)}`);

    if (profiles?.length > 0) {
      console.log("IN LOGIN");
      // dispatch(loginThunk({ username }));

      const isPayment = sessionStorage.getItem("payment");
      setTimeout(() => {
        sessionStorage.removeItem("redirect");
      }, 5000);

      //   setTimeout(async () => {
      if (isPayment) {
        dispatch(loginThunk({ username }));
        sessionStorage.removeItem("payment");
        navigate("/Basket");
      } else {
        const { data } = await api.post("/profiles/success", {
          value: username,
        });
        dispatch(loginThunk({ username }));

        if (data?.success === true) {
          // dispatch(loginThunk({ username }));

          if (cart?.length > 0) {
            navigate("/Basket");
          } else {
            navigate("/OurServices");
          }
        } else {
          navigate("/CompleteProfile");
        }
      }
      //   }, 300);
      return;
    } else {
      console.log("IN REGISTER");
      const {
        data: { _id },
      } = await api.post("/profiles", {
        phone_number: `${username}`,
        unique_key: `${uniqueKey}`,
        username: `${FunctionGetUsername(username)}`,
        phone_code: phoneCode,
      });
      dispatch(loginThunk({ username }));
      navigate("/CompleteProfile");
    }
  } catch (error) {}
};

export default LoginNoBKB;
